import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Field from 'redux-form/es/Field';
import InputSelectField from 'components/Credit24/Core/Controls/InputSelectField';
import InputToggleField from 'components/Credit24/Core/Controls/InputToggleField';
import {
  MEDICARE_CARD_COLOR_BLUE,
  MEDICARE_CARD_COLOR_YELLOW,
  otherCitizenValues,
} from 'consts';
import { useTranslationSuffix } from 'hooks/useTranslationSuffix';

const propTypes = {
  genders: PropTypes.array.isRequired,
  maritalStatuses: PropTypes.array.isRequired,
  visaTypes: PropTypes.array.isRequired,
  dependentsList: PropTypes.array.isRequired,
  selectedResidencyStatus: PropTypes.string,
  medicareCardType: PropTypes.string,
  countries: PropTypes.array.isRequired,
};

const FamilyDetailsAU = (props) => {
  const isOtherCitizenSelected = otherCitizenValues.includes(props.selectedResidencyStatus);
  const isNonGreenMedicareCard = [MEDICARE_CARD_COLOR_BLUE, MEDICARE_CARD_COLOR_YELLOW]
    .includes(props.medicareCardType);

  const shouldShowCountryOrigin = !INCREASE_APP
    && (isOtherCitizenSelected || isNonGreenMedicareCard);

  const translationKeys = {
    title: 'customer.family.title',
    earner: 'family.field.income.earner',
  };

  const translations = useTranslationSuffix('upgrade', translationKeys);

  return (
    <div className="loan-form__step">
      <h1 className="loan-form__step-title">
        <FormattedMessage id={translations.title} />
      </h1>
      <div className="loan-form__step-body">
        <div className="grid">
          <div className="grid__item one-half palm-one-whole">
            <Field
              emptyTextKey="family.field.gender"
              name="gender"
              component={InputSelectField}
              options={props.genders}
              isFullWidth
            />
          </div>
          <div className="grid__item one-half palm-one-whole">
            <Field
              emptyTextKey="family.field.residency"
              name="residencyStatus"
              component={InputSelectField}
              options={props.visaTypes}
              isFullWidth
            />
          </div>
          {shouldShowCountryOrigin && (
            <>
              <div className="grid__item one-half palm-one-whole">
                <Field
                  emptyTextKey="ident_document.passport.country_of_origin.empty_text_key"
                  name="countryOfOrigin"
                  component={InputSelectField}
                  options={props.countries}
                  isFullWidth
                />
              </div>
              <div className="grid__item one-half palm-one-whole" />
            </>
          )}
          <div className="grid__item one-half palm-one-whole">
            <Field
              emptyTextKey="family.field.marital.status"
              name="maritalStatus"
              component={InputSelectField}
              options={props.maritalStatuses}
              isFullWidth
            />
          </div>
          <div className="grid__item one-half palm-one-whole">
            <Field
              emptyTextKey="family.field.dependents"
              name="numberOfDependants"
              component={InputSelectField}
              options={props.dependentsList}
              isFullWidth
            />
          </div>
          <div className="grid__item one-whole">
            <div className="input-group input-group--vertically-spaced">
              <Field
                title={<FormattedMessage id={translations.earner} />}
                name="soleEarnerIndicator"
                component={InputToggleField}
                defaultValue="empty"
                isFullWidth
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

FamilyDetailsAU.propTypes = propTypes;

export default FamilyDetailsAU;
